// extracted by mini-css-extract-plugin
export var readonly = "_j2-1";
export var star = "_j2-0";